import React, { Component } from 'react';

import { Table, TableBody, TableRow, TableRowColumn } from 'material-ui/Table';
import { Card, CardText } from 'material-ui/Card';
import RaisedButton from 'material-ui/RaisedButton';
import CircularProgress from 'material-ui/CircularProgress';

import Config from '../../conf';
import moment from 'moment';

import { Confirm as styles } from './form.css';
import Util from '../../Util';
import 'whatwg-fetch';

class Confirm extends Component {

  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      bookButtonDisabled: false,
      error: false,

      bookingCompleted: false
    };

    this.confirmClicked = this.confirmClicked.bind(this);
    this.sendToBackend = this.sendToBackend.bind(this);
    this.bookButtonClicked = this.bookButtonClicked.bind(this);
    this.retry = this.retry.bind(this);
    this.refreshPage = this.refreshPage.bind(this);
    this.getCarDetails = this.getCarDetails.bind(this);
    this.getCarLocation = this.getCarLocation.bind(this);
  }

  refreshPage() {
    location.reload();
  }

  bookButtonClicked() {
    this.setState({
      bookButtonDisabled: true
    });
  }

  retry() {
    this.setState({
      bookButtonDisabled: false,
      loading: false,
      error: false
    });
    this.confirmClicked();
  }

  sendToBackend(body) {
    // set to loading mode
    this.setState({
      loading: true
    });
    return new Promise((resolve, reject) => {
      fetch(Config.BACKEND_API_URL + 'carpark/create', {
        method: 'post',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
      }).then(response => {
        return response.json().then(data => {
          if (data.status === 200) {
            resolve(data);
          } else {
            throw Error('response status from backend was ' + data.status + ' (data = ' + JSON.stringify(data) + ')');
          }
        });
      }).catch(err => {
        reject(err);
      });
    });
  }

  confirmClicked() {
    const body = {
      name: this.props.details.name,
      email: this.props.details.email,
      phone: this.props.details.phone,
      numberPlate: this.props.details.numberPlate,
      address: Config.ADDRESS,
      carType: this.props.details.carType,
      washType: this.props.details.washType,
      notes: (this.props.details.notes ? this.props.details.notes + '\n' : '') + this.getCarDetails() + '\n' + this.getCarLocation(),
      platform: 'white',
      whiteLabel: Config.CLIENT_NAME,
      clientId: Config.CLIENT_ID,
      date: this.props.details.date,
      startTime: this.props.details.startTime,
      prefix: 'Carparks'
    };
    this.sendToBackend(body).then((response) => {
      this.setState({
        bookingCompleted: true,
        details: response.result
      });
    }).catch(err => {
      this.setState({
        error: true
      });
      console.log('Failed to send to backend: ' + err);
    });
  };

  getCarLocation() {
    let carLocation = '';
    if (this.props.details.carParkLevel) {
      carLocation = 'Level: ' + this.props.details.carParkLevel;
    } else if (this.props.details.carParkLevelColor) {
      carLocation = 'Level color: ' + this.props.details.carParkLevelColor;
    } else if (this.props.details.carParkSpot) {
      carLocation = 'Park Spot' + this.props.details.carParkSpot;
    }
    return carLocation;
  }

  getCarDetails() {
    return this.props.details.numberPlate ?
      'Number Plate: ' + this.props.details.numberPlate : 'Car Brand & Color: ' + this.props.details.carBrandColor
  }

  render() {
    const startTime = (this.props.details.startTime - 0.5) * 60;
    const endTime = (this.props.details.startTime + this.props.details.washDuration + 0.5) * 60;
    const prettyStartDate = moment(this.props.details.date).format('dddd Do of MMMM, YYYY');
    const prettyStartTime = moment().hours(0).minutes(startTime).seconds(0).format('h:mm A');
    const prettyEndTime = moment().hours(0).minutes(endTime).seconds(0).format('h:mm A');
    const prettyWashTimeString = `${prettyStartDate} ${prettyStartTime} - ${prettyEndTime}`;

    const rows = [
      { name: 'Full Name', value: this.props.details.name },
      { name: 'Email Address', value: this.props.details.email },
      { name: 'Mobile Number', value: this.props.details.phone },
      { name: 'Car Location', value: this.getCarLocation() },
      {
        name: 'Car Details', value: this.getCarDetails()
      },
      {
        name: 'Wash Type', value: this.props.details.carType + ' ' + this.props.details.washTypeDisplay + ' $' +
          this.props.details.washPrice.toFixed(2)
      },
      { name: 'Wash Date', value: prettyWashTimeString },
    ];

    return (
      <div>
        {!this.state.error && !this.state.loading && !this.state.bookingCompleted &&
          <Card style={styles.card}>
            <h2 style={styles.title}>
              Confirm
          </h2>

            {this.props.details.isSmallScreen ?
              <div>
                {rows.map((row) => {
                  return (
                    <p key={row.name}>
                      <strong>{row.name}</strong>:
                  <br />
                      {row.value}
                    </p>
                  );
                })}
              </div>
              :
              <Table selectable={false} style={styles.table}>
                <TableBody displayRowCheckbox={false}>
                  {rows.map((row) => {
                    return (
                      <TableRow key={row.name}>
                        <TableRowColumn style={styles.nameCol}>{row.name}</TableRowColumn>
                        <TableRowColumn style={styles.valueCol}>{row.value}</TableRowColumn>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            }

            <RaisedButton style={styles.button}
              label="Back" primary={true} onClick={this.props.back} />
            <RaisedButton
              style={styles.button}
              label="Confirm"
              primary={true}
              onClick={this.confirmClicked}
            />
          </Card>
        }
        {this.state.bookingCompleted &&
          <Card style={styles.card}>
            <h2 style={styles.title}>Finished</h2>
            <CardText>
              <div>
                <strong>
                  Thank you for booking at {Util.toTitleCase(Config.CLIENT_DOMAIN_NAME)} Car Wash.
                </strong>
                <br />
                <br />
                Your clean will be completed by {prettyEndTime} {prettyStartDate == moment().format('dddd Do of MMMM, YYYY') ? 'today' : prettyStartDate} and online payment instructions will be sent to your mobile & email after wash completion.
              {this.state.details && this.state.details.washer && this.state.details.washerPhone &&
                  <p>
                    <strong>To pick up your keys:</strong><br/>
                    Please contact your washer {this.state.details.washer} on {this.state.details.washerPhone} to retrieve your keys by 3:30pm {prettyStartDate == moment().format('dddd Do of MMMM, YYYY') ? 'today' : prettyStartDate}.
                  </p>
                }
                {Config.CLIENT_DOMAIN_NAME.trim().toLowerCase() == 'domain' &&
                  <p>If you arrive after 4pm and we are closed, your keys will be located at the office on Level 2A (blue level) for safekeeping.</p>
                }
                <br /><br />
                <strong>WipeHero</strong>
              </div>
              <div>
                <RaisedButton
                  style={{ ...styles.button, ...{ marginTop: 40 } }}
                  label="Done"
                  primary={true}
                  onClick={this.refreshPage}
                />
              </div>
            </CardText>
          </Card>
        }
        {!this.state.error && this.state.loading && !this.state.bookingCompleted &&
          <Card style={styles.card}>
            <h2 style={styles.title}>Making your booking...</h2>
            <CardText>
              <CircularProgress />
            </CardText>
          </Card>
        }
        {this.state.error && !this.state.bookingCompleted &&
          <Card style={styles.card}>
            <h2 style={styles.title}>Error</h2>
            <CardText>
              <div>
                An error occurred.
            </div>
              <div>
                <RaisedButton
                  style={{ ...styles.button, ...{ marginTop: 40 } }}
                  label="Retry"
                  primary={true}
                  onClick={this.retry}
                />
              </div>
            </CardText>
          </Card>
        }
      </div>
    );
  }
}

export default Confirm;



// WEBPACK FOOTER //
// ./src/app/components/form/Confirm.js